// STP-77: Bundle splitter doesn't yet expose a DELETE/revoke endpoint, so when
// a user dismisses a stuck or failed task we record its task_id locally and
// hide it from the rehydration list on subsequent refreshes. The Celery task
// itself keeps running until it finishes naturally.

const STORAGE_KEY = "medirect.bundleSplitter.dismissedTaskIds";

const readSet = (): Set<string> => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return new Set();
    const parsed = JSON.parse(raw);
    return new Set(
      Array.isArray(parsed) ? parsed.filter((v) => typeof v === "string") : []
    );
  } catch {
    return new Set();
  }
};

const writeSet = (set: Set<string>): void => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...set]));
  } catch {
    // Quota or disabled storage — silently ignore; worst case the entry returns next refresh.
  }
};

export const getDismissedBundleTaskIds = (): Set<string> => readSet();

export const addDismissedBundleTaskId = (taskId: string): void => {
  if (!taskId) return;
  const set = readSet();
  if (set.has(taskId)) return;
  set.add(taskId);
  writeSet(set);
};

// Drop any persisted IDs that the server no longer reports — keeps storage
// from growing unbounded as old tasks age out of the backend.
export const pruneDismissedBundleTaskIds = (
  knownTaskIds: Iterable<string>
): void => {
  const current = readSet();
  if (current.size === 0) return;
  const known = new Set(knownTaskIds);
  const next = new Set([...current].filter((id) => known.has(id)));
  if (next.size === current.size) return;
  writeSet(next);
};
